export default {
    'row': {
        'finished': 'Voltooid',
        'not_finished': 'Niet voltooid',
        'finished_pending': 'Niet voltooide rij afgemaakt'
    }
};
